module.exports = __webpack_public_path__ + "img/side-banner_yoyaku.e8f2fd16.jpg";